export const addressFrag = `
    name
    location
    position {
        lon
        lat
    }
    regionalStructure {
        name
        type
        isoCode
    }
    zip
`;

export const exportFrag = `
    fileName
    pdfBase64
`